export const mbaConsulting = {
  id: 'mba-consulting',
  version: 2,
  renderer: 'enterprise',
  name: 'MBA Consulting Elite',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['mba', 'consulting'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 45,
    visual: 15,
    executive: 35,
    student: 5
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills', 'certifications'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-section'
  },
  metadata: {
    industry: ['Management Consulting', 'Strategy', 'Investment Banking'],
    companies: ['McKinsey', 'BCG', 'Bain', 'Accenture Strategy', 'Oliver Wyman', 'Roland Berger'],
    ats: ['Workday', 'Taleo', 'SuccessFactors'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    density: 'high',
    columns: 1,
    experienceLevel: ['Senior', 'Executive', 'MBA Candidate'],
    careerStage: 'Professional',
    recommendedFor: ['Management Consultants', 'Strategy Analysts', 'MBA Candidates', 'Corporate Strategy Managers'],
    avoidFor: ['Creative Directors', 'Software Developers', 'Academic CVs'],
    dna: ['Traditional-Navy', 'ATS-Perfect', 'Consulting-Elite', 'Gorgia-Serif', 'High-Density'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 99,
      visualAppeal: 80
    },
    hiringManager: {
      firstImpression: "Highly structured, traditional, serious strategy professional",
      scanningStyle: "Rapid vertical scan looking for leadership, team size, degrees, and corporate brands",
      preferredStructure: "Summary, experience, education, skills, certifications",
      dislikes: ["Creative elements", "Ratings", "Icons", "Bullet lists exceeding 6 bullets per job"]
    },
    strategy: {
      goal: "Pass elite corporate screeners and establish maximum business authority",
      focus: "Quantified leadership outcomes, project execution, and school pedigree",
      avoid: ["Gimmicky design layouts", "Secondary sidebar columns"]
    },
    psychology: {
      coreTraits: ["Trustworthiness", "Intellect", "Authority", "Structure"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on corporate strategy achievements, revenue growth, team mentorship, and efficiency metrics. Use formal business language.",
      rewriteStyle: "Formal, executive-focused, consulting-style"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills', 'certifications']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2F2F2F',
    '--color-text-light': '#777777'
  }
};
export default mbaConsulting;
